// assets
import { ReactComponent as Trillion } from '../assets/navigation-icons/trillion.svg';


// icons
const icons = {
    Trillion
};

// Build dynamic Trillion URL that includes the logged-in user's email (if available)
let trillionUrl = 'https://trillion.boxphish.com';
try {
    if (typeof window !== 'undefined' && window.localStorage) {
        const userStr = window.localStorage.getItem('user');
        console.log(userStr)
        if (userStr) {
            const userObj = JSON.parse(userStr);
            const token = userObj && userObj.token;
            if (token) {
                trillionUrl = `https://trillion.boxphish.com/sso/callback?login&token=${encodeURIComponent(token)}`;
            }
        }
    }
} catch (err) {
    // ignore parsing errors and keep default path
    console.warn('Could not build Trillion URL from localStorage user object', err);
}

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const trillionItems = {
    id: 'trillionItems',
    type: 'group',
    title: 'Trillion',
    divider: true,
    children: [
        {
            id: 'trillion',
            title: 'Dark Web Scanning',
            type: 'item',
            url: trillionUrl,
            icon: icons.Trillion,
            disabled: false,
            target: "_blank"
        },
    ]
};

export default trillionItems;
